import { Injectable } from '@angular/core';
import { ApiService, FeatureService } from '@netfoundry-ui/shared/services';

// The rule ActionButtonComponent hides itself by, so a page's own Create button can follow it.
@Injectable({ providedIn: 'root' })
export class ActionButtonVisibilityService {
    isCancelledAccount = false;

    constructor(apiService: ApiService, featureService: FeatureService) {
        apiService.currentSubscription.subscribe((subscription) => {
            this.isCancelledAccount = featureService.isCancelledAccount(subscription);
        });
    }
}
